import { createClient } from "@supabase/supabase-js";
import {envVariables } from "../../common/constants"


const supabaseUrl = envVariables.supabaseUrl;
const supabaseAnonKey = envVariables.supabaseAnonKey;
export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
